import React, { useState } from 'react'
import { routes } from '../../../../../constants';
import { Tabs } from '../../../../common/tabs';
import { useServiceProviderDetailsTabMenuUtils } from '../../../../../utils/tabNavigationUtils/super-admin/useServiceProviderDetailsTabMenuUtils';
import { baseRouteMakerForSuperAdmin } from '../../../../../constants/routeConsts';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

const ServiceProviderDetails = () => {
  
  /* location dependencies */
  const location = useLocation();
  /* location dependencies */

  const serviceProviderDetailsMenuGroup = useServiceProviderDetailsTabMenuUtils();

  const renderTabs = () => {
    const pathname = location.pathname;
    if (pathname.includes(baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_DETAILS))) {
      return serviceProviderDetailsMenuGroup;
    }
  };

  const listRoutesArray = new Array(
    ...serviceProviderDetailsMenuGroup
  )


  return (
    <>
    {
      listRoutesArray.some(
        (element) => element.url === location.pathname
      ) && <Tabs tabsMenuUtils={renderTabs()} />
    }
        
    </>
  )
}

export default ServiceProviderDetails